import { z } from 'zod'

export const passwordCriteriaSchema = z
  .string()
  .min(1, 'auth-common:form.errors.required')
  .min(8, 'auth-common:form.errors.pwd_criteria_length')
  .regex(/[a-z]/, 'auth-common:form.errors.pwd_criteria_lowercase')
  .regex(/[A-Z]/, 'auth-common:form.errors.pwd_criteria_uppercase')
  .regex(/\d/, 'auth-common:form.errors.pwd_criteria_number')
  .regex(/[!@#$%¨&*()\-+]/, 'auth-common:form.errors.pwd_criteria_special_char')

export const passwordSetupSchema = z
  .object({
    newPassword: passwordCriteriaSchema,
    passwordConfirm: z.string().min(1, 'auth-common:form.errors.required'),
  })
  .refine(data => data.newPassword === data.passwordConfirm, {
    message: 'auth-common:form.errors.password_mismatch',
    path: ['passwordConfirm'],
  })

export type PasswordSetupFormValues = z.infer<typeof passwordSetupSchema>
